/* Everyday Endurance - custom JS. Carregado pela seção "EE custom CSS (do not remove)"
   no grupo do rodapé. Não depende de código do BMP; só escuta eventos do navegador. */
(function () {
  'use strict';

  var MAX_SWATCHES = 4;

  /* ===== Card de produto: clique numa bolinha =====
     Escuta na fase de captura: o componente de bolinhas do tema interrompe a
     propagação do evento, então um listener comum no document não o veria.
     (1) Troca a foto do card na hora. O tema só troca a foto depois de buscar o
         card atualizado no servidor; aqui a troca é imediata e o tema, quando a
         resposta chega, repete a mesma troca (preço e link continuam sendo
         atualizados por ele).
     (2) Atualiza o nome da cor embaixo do título (bloco "Nome da cor (EE)"). */
  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!(input instanceof HTMLInputElement)) return;
    if (!input.name || input.name.indexOf('-swatch') === -1) return;
    var card = input.closest('product-card');
    if (!card) return;

    var label = card.querySelector('.ee-variant-name');
    if (label) label.textContent = input.getAttribute('aria-label') || input.value;

    showVariantImage(card, input.dataset.optionMediaId);
  }, true);

  function getSlides(card) {
    return card.querySelectorAll('slideshow-slide[variant-image]');
  }

  function showVariantImage(card, mediaId) {
    if (!mediaId) return;
    var slideshow = card.querySelector('slideshow-component');
    if (!slideshow || typeof slideshow.select !== 'function') return;
    var slides = getSlides(card);
    var found = false;
    for (var i = 0; i < slides.length; i++) {
      if (slides[i].getAttribute('slide-id') === mediaId) { found = true; break; }
    }
    if (!found) return;
    for (var j = 0; j < slides.length; j++) {
      slides[j].hidden = slides[j].getAttribute('slide-id') !== mediaId;
    }
    try {
      slideshow.select({ id: mediaId }, undefined, { animate: false });
    } catch (e) { /* o tema faz a troca quando a resposta do servidor chegar */ }
  }

  /* ===== Card de produto: pré-carregar as fotos das cores visíveis =====
     As fotos das outras cores ficam em slides escondidos com carregamento
     "lazy", então só eram baixadas no primeiro clique. Aqui elas passam para
     "eager" — só as das 4 bolinhas visíveis, só quando o card entra na tela e
     só depois que a página terminou de carregar, para não competir com o que
     aparece primeiro. Desligado quando o navegador pede economia de dados. */
  var saveData = !!(navigator.connection && navigator.connection.saveData);

  function preloadCard(card) {
    if (card.hasAttribute('data-ee-preloaded')) return;
    card.setAttribute('data-ee-preloaded', '');
    var inputs = card.querySelectorAll('input[data-option-media-id]');
    var count = Math.min(inputs.length, MAX_SWATCHES);
    for (var i = 0; i < count; i++) {
      var id = inputs[i].dataset.optionMediaId;
      if (!id) continue;
      var img = card.querySelector('slideshow-slide[slide-id="' + id + '"] img');
      if (img && img.loading === 'lazy') img.loading = 'eager';
    }
  }

  var preloadObserver = null;
  function observeCards() {
    if (saveData || !('IntersectionObserver' in window)) return;
    if (!preloadObserver) {
      var mobile = window.matchMedia('(max-width: 749px)').matches;
      preloadObserver = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (!entries[i].isIntersecting) continue;
          preloadObserver.unobserve(entries[i].target);
          preloadCard(entries[i].target);
        }
      }, mobile ? { threshold: 0.5 } : { rootMargin: '200px 0px' });
    }
    var cards = document.querySelectorAll('product-card:not([data-ee-preloaded]):not([data-ee-observed])');
    for (var i = 0; i < cards.length; i++) {
      if (!cards[i].querySelector('swatches-variant-picker-component')) continue;
      cards[i].setAttribute('data-ee-observed', '');
      preloadObserver.observe(cards[i]);
    }
  }

  var pageLoaded = document.readyState === 'complete';
  function startPreloading() {
    pageLoaded = true;
    var idle = window.requestIdleCallback || function (fn) { return setTimeout(fn, 200); };
    idle(observeCards);
  }

  /* ===== Card de produto: no máximo 4 bolinhas + contador "+N" =====
     A lista de bolinhas do tema mostra quantas couberem na largura. Aqui a
     largura é limitada ao espaço de 4 bolinhas e um contador (que é mais
     estreito que uma bolinha), então a 5a em diante vira "+N".
     O limite fica numa variável CSS no <product-card> (--ee-swatch-cap), e não
     no style da lista: ao clicar numa cor o tema re-renderiza a lista de
     bolinhas com o HTML do servidor, o que apagava o limite e fazia a lista
     abrir todas as cores. O <product-card> não é re-renderizado. */
  function capSwatches() {
    var lists = document.querySelectorAll('product-card swatches-variant-picker-component overflow-list');
    for (var i = 0; i < lists.length; i++) {
      var list = lists[i];
      var card = list.closest('product-card');
      if (!card) continue;
      var items = list.querySelectorAll(':scope > li.variant-option__swatch');
      if (items.length <= MAX_SWATCHES) {
        card.style.removeProperty('--ee-swatch-cap');
        continue;
      }
      var w = items[0].getBoundingClientRect().width;
      if (!w) continue;
      var part = list.shadowRoot && list.shadowRoot.querySelector('[part="list"]');
      var cs = part ? getComputedStyle(part) : null;
      var gap = cs ? parseFloat(cs.columnGap) || 0 : 0;
      var pad = cs ? (parseFloat(cs.paddingLeft) || 0) + (parseFloat(cs.paddingRight) || 0) : 0;
      var cap = pad + MAX_SWATCHES * w + MAX_SWATCHES * gap + w * 0.9;
      card.style.setProperty('--ee-swatch-cap', Math.floor(cap) + 'px');
    }
  }

  var timer;
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      capSwatches();
      if (pageLoaded) observeCards();
    }, 60);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }
  if (pageLoaded) {
    startPreloading();
  } else {
    window.addEventListener('load', function () { schedule(); startPreloading(); });
  }
  window.addEventListener('resize', schedule);
  new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes.length) { schedule(); return; }
    }
  }).observe(document.body || document.documentElement, { childList: true, subtree: true });
})();

/* ===== Quick add: abrir o modal e trocar cor/tamanho mais rápido =====
   O tema, ao clicar no botão de compra rápida, baixa a PÁGINA INTEIRA do
   produto (cabeçalho, rodapé, todas as seções) e só depois abre o modal. Dentro
   do modal, cada clique em cor ou tamanho baixa a página inteira de novo.
   Aqui, sem mexer no código do tema:
   (1) Pede à Shopify só a seção principal do produto (Section Rendering API,
       ?section_id=...), que é tudo o que o modal usa. O id da seção é lido da
       primeira página de produto baixada e guardado na sessão.
   (2) Pré-carrega o produto ao passar o mouse no card (desktop) ou quando o
       card fica visível (mobile, no máximo 2 por vez, nunca com economia de
       dados). No clique, o conteúdo já está pronto.
   (3) Cor e tamanho dentro do modal também passam a pedir só a seção.
   (4) O ícone do botão pulsa enquanto carrega.
   Se a seção não vier como esperado, cai na página inteira (comportamento
   original do tema). */
(function () {
  'use strict';

  var SID_KEY = 'ee-pdp-section-id';
  var TTL = 5 * 60 * 1000;
  var sid = null;
  try { sid = sessionStorage.getItem(SID_KEY); } catch (e) { /* sem storage */ }
  var docs = {};     // chave (pathname + query) -> { t, p: Promise<Document|null> }
  var pathSid = {};  // pathname -> id da seção que funcionou para aquele produto

  function toUrl(u) {
    try { return new URL(u, location.origin); } catch (e) { return null; }
  }

  function sectionIdFrom(doc) {
    var grid = doc.querySelector('[data-product-grid-content]');
    var sec = grid && grid.closest('.shopify-section');
    return sec && sec.id.indexOf('shopify-section-') === 0 ? sec.id.slice(16) : null;
  }

  function fetchDoc(href) {
    return fetch(href, { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.text();
    }).then(function (t) {
      return new DOMParser().parseFromString(t, 'text/html');
    });
  }

  function fullPage(u) {
    return fetchDoc(u.pathname + u.search).then(function (doc) {
      var s = sectionIdFrom(doc);
      if (s) {
        sid = s;
        pathSid[u.pathname] = s;
        try { sessionStorage.setItem(SID_KEY, s); } catch (e) { /* ok */ }
      }
      return doc;
    });
  }

  function load(url) {
    var u = toUrl(url);
    if (!u) return Promise.resolve(null);
    u.searchParams.delete('section_id');
    var key = u.pathname + u.search;
    var hit = docs[key];
    if (hit && Date.now() - hit.t < TTL) return hit.p;

    var p;
    if (sid) {
      var s = sid;
      var su = new URL(u.href);
      su.searchParams.set('section_id', s);
      p = fetchDoc(su.pathname + su.search).then(function (doc) {
        if (!doc.querySelector('[data-product-grid-content]')) throw new Error('seção sem conteúdo');
        pathSid[u.pathname] = s;
        return doc;
      }).catch(function () { return fullPage(u); });
    } else {
      p = fullPage(u);
    }
    p = p.catch(function () { delete docs[key]; return null; });
    docs[key] = { t: Date.now(), p: p };
    return p;
  }

  /* (1) + (4): o tema chama fetchProductPage(url) e espera um Document. */
  customElements.whenDefined('quick-add-component').then(function () {
    var C = customElements.get('quick-add-component');
    var orig = C && C.prototype.fetchProductPage;
    if (typeof orig !== 'function' || C.prototype.__eeFast) return;
    C.prototype.__eeFast = true;
    C.prototype.fetchProductPage = function (url) {
      var self = this;
      if (!url) return orig.call(self, url);
      self.setAttribute('data-ee-loading', '');
      return load(url).then(function (doc) {
        return doc || orig.call(self, url);
      }).finally(function () {
        self.removeAttribute('data-ee-loading');
      });
    };
  });

  /* (3): cor e tamanho dentro do modal. O tema só pede a seção quando o seletor
     está dentro de um card; no modal ele pede a página inteira. */
  customElements.whenDefined('variant-picker').then(function () {
    var V = customElements.get('variant-picker');
    var orig = V && V.prototype.buildRequestUrl;
    if (typeof orig !== 'function' || V.prototype.__eeFast) return;
    V.prototype.__eeFast = true;
    V.prototype.buildRequestUrl = function () {
      var url = orig.apply(this, arguments);
      try {
        if (!this.closest('quick-add-dialog')) return url;
        var u = toUrl(url);
        if (!u || u.searchParams.has('section_id')) return url;
        var s = pathSid[u.pathname];
        if (!s) return url;
        return url + (url.indexOf('?') === -1 ? '?' : '&') + 'section_id=' + encodeURIComponent(s);
      } catch (e) {
        return url;
      }
    };
  });

  /* (2): pré-carregamento */
  var saveData = !!(navigator.connection && navigator.connection.saveData);

  function cardUrl(card) {
    var u = null;
    try { u = card.productPageUrl; } catch (e) { /* ok */ }
    if (!u) {
      var a = card.querySelector('a[href*="/products/"]');
      u = a && a.href;
    }
    return u;
  }

  function warm(card) {
    if (!card || card.__eeWarm || !card.querySelector('quick-add-component')) return null;
    var u = cardUrl(card);
    if (!u) return null;
    card.__eeWarm = true;
    return load(u);
  }

  // Desktop: mouse parado ~90 ms sobre o card.
  var hoverTimer = null;
  var hoverCard = null;
  document.addEventListener('pointerover', function (e) {
    if (e.pointerType === 'touch') return;
    var card = e.target && e.target.closest && e.target.closest('product-card');
    if (!card || card === hoverCard) return;
    hoverCard = card;
    clearTimeout(hoverTimer);
    hoverTimer = setTimeout(function () { warm(card); }, 90);
  }, { passive: true });

  // Qualquer aparelho: toque ou foco no card.
  function warmFromEvent(e) {
    var card = e.target && e.target.closest && e.target.closest('product-card');
    if (card) warm(card);
  }
  document.addEventListener('touchstart', warmFromEvent, { passive: true, capture: true });
  document.addEventListener('focusin', warmFromEvent, true);

  // Mobile: cards visíveis, no máximo 2 downloads ao mesmo tempo.
  var mobile = window.matchMedia('(max-width: 749px)').matches;
  if (mobile && !saveData && 'IntersectionObserver' in window) {
    var queue = [];
    var running = 0;
    var pump = function () {
      while (running < 2 && queue.length) {
        var p = warm(queue.shift());
        if (!p) continue;
        running++;
        p.then(done, done);
      }
    };
    var done = function () { running--; pump(); };
    var io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (!entries[i].isIntersecting) continue;
        io.unobserve(entries[i].target);
        queue.push(entries[i].target);
      }
      pump();
    }, { threshold: 0.6 });
    var observe = function () {
      var cards = document.querySelectorAll('product-card:not([data-ee-qa-observed])');
      for (var i = 0; i < cards.length; i++) {
        if (!cards[i].querySelector('quick-add-component')) continue;
        cards[i].setAttribute('data-ee-qa-observed', '');
        io.observe(cards[i]);
      }
    };
    var start = function () {
      var idle = window.requestIdleCallback || function (fn) { return setTimeout(fn, 300); };
      idle(observe);
      var t;
      new MutationObserver(function () {
        clearTimeout(t);
        t = setTimeout(observe, 200);
      }).observe(document.body, { childList: true, subtree: true });
    };
    if (document.readyState === 'complete') start();
    else window.addEventListener('load', start);
  }

  // (4) sinal de carregamento no botão
  var st = document.createElement('style');
  st.textContent =
    'quick-add-component[data-ee-loading] .quick-add__button{cursor:progress}' +
    'quick-add-component[data-ee-loading] .add-to-cart-icon{animation:ee-qa-pulse .8s ease-in-out infinite}' +
    '@keyframes ee-qa-pulse{50%{opacity:.3}}' +
    '@media (prefers-reduced-motion:reduce){quick-add-component[data-ee-loading] .add-to-cart-icon{animation:none;opacity:.5}}';
  document.head.appendChild(st);
})();

/* ===== Quick add: cor e tamanho no modal =====
   Cada clique em cor ou tamanho no modal busca a seção do produto no servidor e
   o tema SUBSTITUI a galeria inteira pela da resposta (replaceWith), mesmo quando
   as fotos são as mesmas. Aqui, sem mexer no código do tema:
   (1) Tamanho: se a galeria da resposta tem as mesmas fotos da galeria aberta
       (trocar só o tamanho), ela é retirada da resposta antes de chegar ao
       tema — a foto não é recarregada. Preço, estoque e botão continuam sendo
       atualizados normalmente.
   (2) Cor: quando o modal abre (e depois de cada troca), busca em segundo plano
       a resposta de cada cor com o tamanho atual e pré-carrega a primeira foto
       de cada uma. No clique, a resposta sai da memória e a foto já está
       baixada. Até 3 downloads por vez no desktop, 2 no mobile; nada com
       economia de dados.
   Só age em pedidos de variante feitos com o modal de compra rápida aberto;
   qualquer falha cai no pedido normal ao servidor. */
(function () {
  'use strict';

  if (typeof window.fetch !== 'function' || typeof Response !== 'function') return;

  var nativeFetch = window.fetch.bind(window);
  var TTL = 5 * 60 * 1000;
  var cache = {}; // chave -> { t, p: Promise<string> }
  var saveData = !!(navigator.connection && navigator.connection.saveData);
  var mobile = window.matchMedia('(max-width: 749px)').matches;
  var LIMIT = mobile ? 2 : 3;

  function dialogEl() { return document.querySelector('quick-add-dialog'); }
  function modalOpen() {
    var d = dialogEl();
    var dlg = d && d.querySelector('dialog');
    return !!(dlg && dlg.open);
  }

  function parse(url) {
    try { return new URL(url, location.origin); } catch (e) { return null; }
  }

  function keyOf(u) {
    var ov = u.searchParams.get('option_values');
    var sid = u.searchParams.get('section_id');
    if (!ov || !sid) return null;
    return u.pathname + '|' + ov + '|' + sid + '|' + (u.searchParams.get('view') || '');
  }

  function getText(href, key) {
    var hit = cache[key];
    if (hit && Date.now() - hit.t < TTL) return hit.p;
    var p = nativeFetch(href, { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.text();
    });
    p.catch(function () { delete cache[key]; });
    cache[key] = { t: Date.now(), p: p };
    return p;
  }

  function gallerySignature(g) {
    if (!g) return null;
    var parts = [];
    var slides = g.querySelectorAll('slideshow-slide');
    for (var i = 0; i < slides.length; i++) parts.push(slides[i].getAttribute('slide-id') || '');
    var imgs = g.querySelectorAll('img');
    for (var j = 0; j < imgs.length; j++) parts.push((imgs[j].getAttribute('src') || '').split('?')[0]);
    return parts.join('|');
  }

  // (1) retira a galeria da resposta quando as fotos não mudaram
  function keepGalleryIfSame(text) {
    try {
      var current = gallerySignature(document.querySelector('quick-add-dialog media-gallery'));
      if (!current) return text;
      var doc = new DOMParser().parseFromString(text, 'text/html');
      var incoming = doc.querySelector('media-gallery');
      if (!incoming || gallerySignature(incoming) !== current) return text;
      incoming.remove();
      return '<!DOCTYPE html>' + doc.documentElement.outerHTML;
    } catch (e) {
      return text;
    }
  }

  function abortError() {
    try { return new DOMException('The operation was aborted.', 'AbortError'); } catch (e) {
      var err = new Error('Aborted'); err.name = 'AbortError'; return err;
    }
  }

  window.fetch = function (input, init) {
    try {
      var href = typeof input === 'string' ? input : (input instanceof URL ? input.href : null);
      var method = init && init.method ? String(init.method).toUpperCase() : 'GET';
      if (href && method === 'GET' && modalOpen()) {
        var u = parse(href);
        var key = u && u.origin === location.origin && keyOf(u);
        if (key) {
          var signal = init && init.signal;
          var p = getText(u.pathname + u.search, key).catch(function () {
            return nativeFetch(href, init).then(function (r) { return r.text(); });
          });
          return new Promise(function (resolve, reject) {
            var aborted = false;
            if (signal) {
              if (signal.aborted) { reject(abortError()); return; }
              signal.addEventListener('abort', function () { aborted = true; reject(abortError()); }, { once: true });
            }
            p.then(function (text) {
              if (aborted) return;
              resolve(new Response(keepGalleryIfSame(text), {
                status: 200,
                headers: { 'Content-Type': 'text/html; charset=utf-8' }
              }));
            }, function (err) {
              if (!aborted) reject(err);
            });
          });
        }
      }
    } catch (e) { /* segue para o fetch normal */ }
    return nativeFetch(input, init);
  };

  // (2) pré-carregamento das cores
  function groupsOf(vp) {
    var out = [];
    var sets = vp.querySelectorAll('fieldset, select');
    for (var i = 0; i < sets.length; i++) {
      var el = sets[i];
      if (el.tagName === 'SELECT') {
        var opt = el.options[el.selectedIndex];
        out.push({ el: el, value: opt && opt.dataset.optionValueId, inputs: [] });
      } else {
        var inputs = el.querySelectorAll('input[type="radio"][data-option-value-id]');
        if (!inputs.length) continue;
        var checked = el.querySelector('input[type="radio"][data-option-value-id]:checked');
        out.push({ el: el, value: checked && checked.dataset.optionValueId, inputs: inputs });
      }
    }
    return out;
  }

  function isColorGroup(g) {
    if (!g.inputs.length) return false;
    var legend = g.el.querySelector('legend');
    var name = (legend ? legend.textContent : '') + ' ' + (g.inputs[0].name || '');
    if (/colou?r|\bcor\b/i.test(name)) return true;
    return /swatch/i.test(g.el.className || '');
  }

  function preloadFirstImage(text) {
    try {
      var doc = new DOMParser().parseFromString(text, 'text/html');
      var img = doc.querySelector('media-gallery slideshow-slide img') || doc.querySelector('media-gallery img');
      if (!img) return;
      var pre = new Image();
      if (img.getAttribute('sizes')) pre.sizes = img.getAttribute('sizes');
      if (img.getAttribute('srcset')) pre.srcset = img.getAttribute('srcset');
      pre.src = img.getAttribute('src') || '';
    } catch (e) { /* ok */ }
  }

  var queue = [];
  var running = 0;
  function pump() {
    while (running < LIMIT && queue.length) {
      var job = queue.shift();
      if (cache[job.key]) continue;
      running++;
      getText(job.href, job.key).then(preloadFirstImage, function () {}).then(function () {
        running--;
        pump();
      });
    }
  }

  function prefetchColors() {
    if (saveData || !modalOpen()) return;
    var d = dialogEl();
    var vp = d && d.querySelector('variant-picker');
    if (!vp) return;
    var base = parse(vp.dataset.productUrl || '');
    if (!base) return;
    var groups = groupsOf(vp);
    if (!groups.length) return;
    var values = groups.map(function (g) { return g.value; });
    var ci = -1;
    for (var i = 0; i < groups.length; i++) { if (isColorGroup(groups[i])) { ci = i; break; } }
    if (ci === -1 || !values[ci]) return;
    var sid = null;
    try { sid = sessionStorage.getItem('ee-pdp-section-id'); } catch (e) { /* ok */ }
    if (!sid) return;
    var inputs = groups[ci].inputs;
    queue.length = 0;
    for (var j = 0; j < inputs.length; j++) {
      var id = inputs[j].dataset.optionValueId;
      if (!id || id === values[ci] || inputs[j].disabled) continue;
      var vals = values.slice();
      vals[ci] = id;
      /* Igual ao tema: só as opções marcadas, na ordem da página. Sem tamanho
         escolhido (gate do BMP), o pedido do tema leva só a cor. */
      vals = vals.filter(function (v) { return !!v; });
      var href = base.pathname + '?option_values=' + vals.join(',') + '&section_id=' + encodeURIComponent(sid);
      var key = keyOf(parse(href));
      if (key && !cache[key]) queue.push({ href: href, key: key });
    }
    pump();
  }

  var timer = null;
  function schedule(ms) {
    clearTimeout(timer);
    timer = setTimeout(prefetchColors, ms);
  }

  function watchDialog() {
    var d = dialogEl();
    var dlg = d && d.querySelector('dialog');
    if (!dlg) return false;
    new MutationObserver(function () { if (dlg.open) schedule(250); })
      .observe(dlg, { attributes: true, attributeFilter: ['open'] });
    d.addEventListener('change', function () { schedule(500); }, true);
    return true;
  }

  if (!watchDialog()) {
    document.addEventListener('DOMContentLoaded', watchDialog);
  }
})();


/* ===== Quick add: layout do modal (23/09) =====
   Acrescenta ao modal de compra rápida, sem editar arquivo do tema:
   - eyebrow com o nome da coleção acima do nome e uma linha de copy abaixo do
     preço (desktop). O nome vem do bloco "Coleção no quick add (EE)" da página
     de produto (templates/product.json), lido quando o tema monta o modal;
   - botão "Secure checkout" (adiciona e vai direto ao checkout), acima do "Add to cart";
   - linha de confiança centralizada e link "View full details ↗".
   O selo "Sale" e o resto do visual estão no CSS (bloco de mesmo nome).
   O modal é re-montado pelo tema (morph) a cada abertura e troca de variante:
   um MutationObserver repõe o que sumir. Tudo é idempotente. */
(function () {
  var collectionName = ''; /* definido a cada abertura do modal, ver fim do bloco */
  var HOOK = 'Soft, lightweight cotton made to stay on from the meet-up to the coffee after.';
  var BUY_LABEL = 'Secure checkout';
  var BUY_BUSY = 'Going to checkout…';
  var ICON_LOCK = '<svg viewBox="10 10 28 28" aria-hidden="true" focusable="false"><path d="M18 22.5 V18.75 a6 6 0 0 1 12 0 V22.5"/><rect x="13.5" y="22.5" width="21" height="15" rx="1.5"/><circle cx="24" cy="28.4" r="1.7"/><path d="M24 30.1 V32.9"/></svg>';
  var ICON_BOX = '<svg viewBox="10 10 28 28" aria-hidden="true" focusable="false"><path d="M24 12.5 L36.5 19 V31 L24 37.5 L11.5 31 V19 Z"/><path d="M11.5 19 L24 25.5 L36.5 19"/><path d="M17.75 15.75 L30.25 22.25"/></svg>';
  var ICON_RETURN = '<svg viewBox="10 10 28 28" aria-hidden="true" focusable="false"><path d="M 29.07 13.12 A 12.0 12.0 0 1 0 35.59 20.89"/><path d="M 39.88 24.92 L 35.59 20.89 L 33.89 26.53"/></svg>';

  function root() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  function el(tag, cls, html) {
    var n = document.createElement(tag);
    n.className = cls;
    if (html != null) n.innerHTML = html;
    return n;
  }

  function productLink(content) {
    return content.querySelector('.view-product-title a, .product-header a:not(product-price *)');
  }

  function decorate(content) {
    var title = content.querySelector('.view-product-title');
    var header = content.querySelector('.product-header'); /* layout mobile do tema */

    /* Eyebrow com o nome da coleção: dentro do título (desktop) ou do
       cabeçalho (mobile). Sem coleção, sem eyebrow. */
    var host = header || title;
    var eb = host && host.querySelector(':scope > .ee-qa-eyebrow');
    if (host && collectionName) {
      if (!eb) {
        eb = el('p', 'ee-qa-eyebrow');
        host.insertBefore(eb, host.firstChild);
      }
      if (eb.textContent !== collectionName) eb.textContent = collectionName;
    } else if (eb) {
      eb.remove();
    }

    /* Copy curta logo depois do preço (só desktop: no mobile a folha é baixa). */
    var details = content.querySelector('.product-details');
    var price = details && details.querySelector('product-price');
    if (price && price.parentNode && !price.parentNode.querySelector(':scope > .ee-qa-hook')) {
      price.insertAdjacentElement('afterend', el('p', 'ee-qa-hook', HOOK));
    }

    var form = content.querySelector('product-form-component');
    if (!form) return;
    var buttons = form.querySelector('.product-form-buttons');
    var atc = form.querySelector('[ref="addToCartButton"]');
    if (!buttons || !atc) return;

    /* Buy now */
    var buy = buttons.querySelector(':scope > .ee-qa-buy');
    if (!buy) {
      buy = el('button', 'ee-qa-buy', ICON_LOCK + '<span class="ee-qa-buy__label">' + BUY_LABEL + '</span>');
      buy.type = 'button';
      buttons.insertBefore(buy, buttons.firstChild);
    }
    if (!buy.hasAttribute('aria-busy') && buy.disabled !== atc.disabled) buy.disabled = atc.disabled;

    /* Erro do Buy now */
    if (!buttons.querySelector(':scope > .ee-qa-error')) {
      var err = el('p', 'ee-qa-error');
      err.setAttribute('role', 'alert');
      err.hidden = true;
      buttons.appendChild(err);
    }

    /* Linha de confiança + link para a página do produto */
    if (!form.querySelector(':scope > .ee-qa-trust')) {
      form.appendChild(el('div', 'ee-qa-trust',
        '<span>' + ICON_BOX + 'Free shipping over $49</span><span>' + ICON_RETURN + '30-Day Happiness Guarantee</span>'));
    }
    var more = form.querySelector(':scope > .ee-qa-more');
    if (!more) {
      more = el('a', 'ee-qa-more', '<span>View full details</span><span aria-hidden="true">↗</span>');
      form.appendChild(more);
    }
    var link = productLink(content);
    if (link && more.getAttribute('href') !== link.getAttribute('href')) {
      more.setAttribute('href', link.getAttribute('href'));
    }
  }

  function sizeMissing(form) {
    if (!form.hasAttribute('data-bmp-size-required')) return false;
    if (form.getAttribute('data-bmp-size-satisfied') === 'true') return false;
    var scope = form.closest('#quick-add-modal-content') || document;
    var fs = scope.querySelector('[data-bmp-size-fieldset]');
    if (fs && fs.querySelector('input:checked')) return false;
    return true;
  }

  function showError(buy, msg) {
    var err = buy.parentNode && buy.parentNode.querySelector('.ee-qa-error');
    if (!err) return;
    err.textContent = msg || '';
    err.hidden = !msg;
  }


  /* ----- Tela do checkout (tênis correndo) -----
     Configurada pela seção "EE — Tela do checkout" do rodapé
     (sections/ee-checkout-loader.liquid), que publica #ee-checkout-loader-config.
     Sem a seção (escondida no editor) ou com "Mostrar a tela" desmarcado, não
     aparece nada além do "Going to checkout…" no botão. Só aparece se a espera
     passar de 0,3 s; some sozinha quando o checkout abre (troca de página), em
     erro, ao fechar o modal ou ao voltar pelo botão Voltar. */
  var SHOE = '<svg viewBox="-8 0 72 32" aria-hidden="true"><g class="ee-go__body"><g stroke="#C56438" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path fill="#FFFDF9" d="M8 21.5 C6.8 16.5 7 11.5 9.2 8.4 C10.5 6.6 12.8 6.8 14 8.6 C14.9 10 16.1 10.6 17.4 9.8 L19.2 6.6 C19.8 5.6 21.1 5.4 22 6.1 C27 10.2 33 13.4 40 15.2 C47 16.9 55 17.8 59 19.4 C60.6 20.1 61.2 21 61 22 Z"/><path fill="#F4DCCD" d="M6 22.3 C5.8 26 8 28.2 12 28.2 L50 28.2 C56.5 28.2 61.5 25.8 62.2 22.2 C62.2 21.6 61.6 21.2 60.8 21.2 L8.4 21.2 C7 21.2 6.1 21.5 6 22.3 Z"/></g><g fill="none" stroke="#C56438" stroke-width="1.3" stroke-linecap="round"><path d="M24.6 9.6 l-1.9 2.5 M28.6 11.8 l-1.9 2.5 M32.6 13.5 l-1.7 2.5"/><path d="M12.5 17.4 C20 15.3 28 15.6 36.5 18.2" opacity=".9"/><path d="M15 19.5 C21 18.3 27 18.5 33.5 19.8" opacity=".55"/><path d="M51.5 18.1 C55.2 18.8 58.3 19.9 60 21.2" opacity=".6"/><path d="M10 25 H55" opacity=".45"/><path d="M9.2 8.4 L7.9 5.6"/></g><g class="ee-go__wing"><g transform="translate(-3 -2)"><g class="ee-go__wf" fill="#FFFDF9" stroke="#17354B" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"><path d="M10 13.5 C7 9.2 3 6.6 -1.8 5.8 C0 7.4 0.9 8.8 1.1 10.2 C-0.9 10 -2.6 10.6 -3.3 11.7 C-1.3 12.1 -0.1 12.9 0.3 13.9 C-1.1 14.3 -2.1 15.1 -2.3 16.1 C2 16.7 6.8 16 10 13.5 Z"/><path d="M8.2 13.2 C5.6 11.6 3.6 11 1.6 10.9" fill="none" opacity=".6"/></g></g></g></g></svg>';
  var loader = { show: null, rot: null, fade: null };

  function loaderConfig() {
    var c = document.getElementById('ee-checkout-loader-config');
    if (!c) return null;
    try { return JSON.parse(c.textContent); } catch (e) { return null; }
  }

  function loaderLines(txt) {
    return String(txt || '').split(/\r?\n/).map(function (l) { return l.trim(); }).filter(Boolean);
  }

  function stopLoader() {
    clearTimeout(loader.show); clearInterval(loader.rot); clearTimeout(loader.fade);
    loader.show = loader.rot = loader.fade = null;
    var on = document.querySelectorAll('.ee-go.is-on');
    for (var i = 0; i < on.length; i++) on[i].classList.remove('is-on');
  }

  function loaderOverlay(dlg) {
    var ov = dlg.querySelector(':scope > .ee-go');
    if (ov) return ov;
    ov = el('div', 'ee-go',
      '<p class="ee-go__kicker">Secure checkout</p>' +
      '<div class="ee-go__world"><span class="ee-go__ground"></span>' +
      '<span class="ee-go__finish"><i class="ee-go__post ee-go__post--l"></i><i class="ee-go__post ee-go__post--r"></i>' +
      '<i class="ee-go__tape ee-go__tape--1"></i><i class="ee-go__tape ee-go__tape--2"></i></span>' +
      '<span class="ee-go__shoe"><span class="ee-go__lines"><i></i><i></i><i></i></span>' + SHOE + '</span></div>' +
      '<p class="ee-go__line"></p>');
    ov.setAttribute('role', 'status');
    ov.setAttribute('aria-live', 'polite');
    dlg.appendChild(ov);
    dlg.addEventListener('close', stopLoader);
    return ov;
  }

  function startLoader(buy) {
    stopLoader();
    var cfg = loaderConfig();
    var dlg = buy.closest('dialog');
    if (!cfg || !dlg) return;
    var scene = cfg.scene === 'a' || cfg.scene === 'b' ? cfg.scene : (Math.random() < 0.5 ? 'a' : 'b');
    var lines = loaderLines(cfg[scene]);
    if (!lines.length) lines = [BUY_BUSY];
    var ov = loaderOverlay(dlg);
    ov.classList.remove('ee-go--a', 'ee-go--b');
    ov.classList.add('ee-go--' + scene);
    var line = ov.querySelector('.ee-go__line');
    var i = 0;
    line.textContent = lines[0];
    line.classList.remove('is-out');
    loader.show = setTimeout(function () {
      ov.classList.add('is-on');
      if (lines.length < 2) return;
      loader.rot = setInterval(function () {
        line.classList.add('is-out');
        loader.fade = setTimeout(function () {
          i = (i + 1) % lines.length;
          line.textContent = lines[i];
          line.classList.remove('is-out');
        }, 200);
      }, 1200);
    }, 300);
  }

  function onBuy(buy) {
    var form = buy.closest('product-form-component');
    var atc = form && form.querySelector('[ref="addToCartButton"]');
    if (!form || !atc || buy.disabled) return;
    showError(buy, '');

    /* Sem tamanho escolhido: deixa o gate do tema mostrar o aviso de sempre. */
    if (sizeMissing(form)) { atc.click(); return; }

    var idInput = form.querySelector('input[name="id"]');
    var qtyInput = form.querySelector('input[name="quantity"]');
    var id = idInput && parseInt(idInput.value, 10);
    var qty = (qtyInput && parseInt(qtyInput.value, 10)) || 1;
    if (!id) { atc.click(); return; }

    var label = buy.querySelector('.ee-qa-buy__label');
    buy.setAttribute('aria-busy', 'true');
    buy.disabled = true;
    if (label) label.textContent = BUY_BUSY;
    try { startLoader(buy); } catch (e) { /* a tela é enfeite: nunca atrapalha a compra */ }

    fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: qty }] })
    })
      .then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (data) {
          if (!r.ok) throw new Error(data.description || data.message || 'Something went wrong. Try again.');
          window.location.href = root() + 'checkout';
        });
      })
      .catch(function (e) {
        stopLoader();
        buy.removeAttribute('aria-busy');
        buy.disabled = atc.disabled;
        if (label) label.textContent = BUY_LABEL;
        showError(buy, e.message);
      });
  }

  document.addEventListener('click', function (e) {
    var buy = e.target instanceof Element ? e.target.closest('#quick-add-modal-content .ee-qa-buy') : null;
    if (!buy) return;
    e.preventDefault();
    onBuy(buy);
  });

  /* Volta de página (bfcache) depois de ir ao checkout: destrava o botão. */
  window.addEventListener('pageshow', function () {
    stopLoader();
    document.querySelectorAll('.ee-qa-buy[aria-busy]').forEach(function (b) {
      b.removeAttribute('aria-busy');
      var l = b.querySelector('.ee-qa-buy__label');
      if (l) l.textContent = BUY_LABEL;
      var atc = b.closest('product-form-component');
      atc = atc && atc.querySelector('[ref="addToCartButton"]');
      b.disabled = atc ? atc.disabled : false;
    });
  });

  /* Nome da coleção: o tema passa o conteúdo da página de produto para
     updateQuickAddModal(grid) antes de montar o modal (no mobile ele descarta
     .product-details, onde o dado fica). Lê ali e guarda. */
  customElements.whenDefined('quick-add-component').then(function () {
    var C = customElements.get('quick-add-component');
    var orig = C && C.prototype.updateQuickAddModal;
    if (typeof orig !== 'function' || C.prototype.__eeCollection) return;
    C.prototype.__eeCollection = true;
    C.prototype.updateQuickAddModal = function (grid) {
      try {
        var d = grid && grid.querySelector('[data-ee-collection]');
        collectionName = d ? (d.getAttribute('data-ee-collection') || '').trim() : '';
      } catch (e) { collectionName = ''; }
      return orig.apply(this, arguments);
    };
  });

  function watch() {
    var content = document.getElementById('quick-add-modal-content');
    if (!content) return false;
    var queued = false;
    function run() {
      queued = false;
      try { decorate(content); } catch (err) { /* nunca quebrar o modal do tema */ }
    }
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(run);
    }).observe(content, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled'] });
    run();
    return true;
  }

  if (!watch()) document.addEventListener('DOMContentLoaded', watch);
})();


/* ===== Página de produto: trocar cor mais rápido (23/09) =====
   Na página do produto, cada clique numa cor fazia o tema baixar a PÁGINA
   INTEIRA de novo e só então montar a galeria nova — e a foto da cor nova só
   começava a baixar nessa hora. Aqui, sem mexer no código do tema:
   (1) O pedido de cor/tamanho pede só a seção principal do produto
       (?section_id=...), não a página inteira. Se a seção não vier como
       esperado, pede a página inteira (comportamento original); duas falhas
       da seção desligam este bloco até a próxima página.
   (2) Depois que a página carrega, busca em segundo plano a resposta de cada
       cor (com o tamanho escolhido, ou só a cor se o tamanho ainda não foi
       escolhido) e pré-carrega a primeira foto de cada uma — e as miniaturas,
       no desktop. No clique, a resposta sai da memória e a foto já está
       baixada. 3 downloads por vez no desktop, 2 no mobile; nada com economia
       de dados ou conexão 2G. Repete depois de cada troca (o tamanho muda a
       resposta, não as fotos).
   (3) Mouse parado ~60 ms sobre uma cor, foco ou toque: aquela cor é buscada
       na hora, com miniaturas, sem esperar a fila.
   (4) Trocar só o tamanho não remonta a galeria quando as fotos são as mesmas:
       a foto não pisca e o cliente continua na foto que estava vendo.
   Só age no seletor principal da página de produto (fora de card e do modal
   de compra rápida). Qualquer falha cai no pedido normal ao servidor. */
(function () {
  'use strict';

  if (typeof window.fetch !== 'function' || typeof Response !== 'function' ||
      typeof DOMParser !== 'function' || !window.customElements) return;

  var prevFetch = window.fetch; /* pode já ser o do modal de compra rápida */
  function baseFetch(input, init) { return prevFetch.call(window, input, init); }

  var TTL = 5 * 60 * 1000;
  var conn = navigator.connection || {};
  var saveData = !!conn.saveData || /2g$/.test(conn.effectiveType || '');
  var mobile = window.matchMedia('(max-width: 749px)').matches;
  var LIMIT = mobile ? 2 : 3;
  var cache = {}; /* chave -> { t, p: Promise<string> } */
  var failures = 0; /* 2 falhas da seção → desliga tudo, volta ao tema puro */
  function off() { return failures >= 2; }

  function parse(url) {
    try { return new URL(url, location.origin); } catch (e) { return null; }
  }

  function modalOpen() {
    var dlg = document.querySelector('quick-add-dialog dialog');
    return !!(dlg && dlg.open);
  }

  /* Seletor principal da página de produto (nunca o de card, modal ou
     produto em destaque). */
  function pdpPicker() {
    var list = document.querySelectorAll('variant-picker[data-template-product-match="true"]');
    for (var i = 0; i < list.length; i++) {
      if (!list[i].closest('product-card, quick-add-dialog, dialog, featured-product-information')) return list[i];
    }
    return null;
  }

  function sectionIdOf(vp) {
    if (!vp) return null;
    if (vp.dataset.sectionId) return vp.dataset.sectionId;
    var sec = vp.closest('.shopify-section');
    return sec && sec.id.indexOf('shopify-section-') === 0 ? sec.id.slice(16) : null;
  }

  function keyOf(u) {
    var ov = u.searchParams.get('option_values');
    var sid = u.searchParams.get('section_id');
    if (!ov || !sid) return null;
    return u.pathname + '|' + ov + '|' + sid + '|' + (u.searchParams.get('view') || '');
  }

  function fresh(key) {
    var hit = cache[key];
    return !!(hit && Date.now() - hit.t < TTL);
  }

  function prune() {
    var now = Date.now();
    for (var k in cache) {
      if (Object.prototype.hasOwnProperty.call(cache, k) && now - cache[k].t >= TTL) delete cache[k];
    }
  }

  function getText(href, key) {
    if (fresh(key)) return cache[key].p;
    prune();
    var p = baseFetch(href, { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.text();
    }).then(function (t) {
      if (t.indexOf('<variant-picker') === -1) throw new Error('seção sem seletor');
      return t;
    });
    p.catch(function () {
      failures++;
      if (cache[key] && cache[key].p === p) delete cache[key];
    });
    cache[key] = { t: Date.now(), p: p };
    return p;
  }

  function abortError() {
    try { return new DOMException('The operation was aborted.', 'AbortError'); } catch (e) {
      var err = new Error('Aborted'); err.name = 'AbortError'; return err;
    }
  }

  /* Pedido de variante do seletor principal? Devolve a chave do cache. */
  function pdpKey(u) {
    if (!u || u.origin !== location.origin) return null;
    var vp = pdpPicker();
    var sid = sectionIdOf(vp);
    var base = vp && parse(vp.dataset.productUrl || '');
    if (!sid || !base || u.pathname !== base.pathname || u.searchParams.get('section_id') !== sid) return null;
    return keyOf(u);
  }

  /* (1) + (2): responde da memória; se a seção falhar, página inteira. */
  window.fetch = function (input, init) {
    try {
      var href = typeof input === 'string' ? input : (input instanceof URL ? input.href : null);
      var method = init && init.method ? String(init.method).toUpperCase() : 'GET';
      if (href && method === 'GET' && !modalOpen()) {
        var u = parse(href);
        var key = pdpKey(u);
        if (key) {
          var signal = init && init.signal;
          var full = new URL(u.href);
          full.searchParams.delete('section_id');
          var p = getText(u.pathname + u.search, key).catch(function () {
            return baseFetch(full.pathname + full.search, { credentials: 'same-origin', signal: signal })
              .then(function (r) { return r.text(); });
          });
          return new Promise(function (resolve, reject) {
            var aborted = false;
            if (signal) {
              if (signal.aborted) { reject(abortError()); return; }
              signal.addEventListener('abort', function () { aborted = true; reject(abortError()); }, { once: true });
            }
            p.then(function (text) {
              if (aborted) return;
              resolve(new Response(text, {
                status: 200,
                headers: { 'Content-Type': 'text/html; charset=utf-8' }
              }));
            }, function (err) {
              if (!aborted) reject(err);
            });
          });
        }
      }
    } catch (e) { /* segue para o fetch normal */ }
    return prevFetch.apply(window, arguments);
  };

  /* (1): o tema só pede a seção dentro de card; na página pede a página toda. */
  customElements.whenDefined('variant-picker').then(function () {
    var V = customElements.get('variant-picker');
    var orig = V && V.prototype.buildRequestUrl;
    if (typeof orig !== 'function' || V.prototype.__eePdpFast) return;
    V.prototype.__eePdpFast = true;
    V.prototype.buildRequestUrl = function (selectedOption) {
      var url = orig.apply(this, arguments);
      try {
        if (off() || this !== pdpPicker()) return url;
        /* combined listing troca de produto: o tema precisa da página inteira */
        if (selectedOption && selectedOption.dataset && selectedOption.dataset.connectedProductUrl) return url;
        if (/[?&]section_id=/.test(url)) return url;
        var sid = sectionIdOf(this);
        if (!sid) return url;
        return url + (url.indexOf('?') === -1 ? '?' : '&') + 'section_id=' + encodeURIComponent(sid);
      } catch (e) {
        return url;
      }
    };
  });

  /* (2): pré-carregamento das cores */
  function groupsOf(vp) {
    var out = [];
    var sets = vp.querySelectorAll('fieldset, select');
    for (var i = 0; i < sets.length; i++) {
      var el = sets[i];
      if (el.tagName === 'SELECT') {
        var opt = el.options[el.selectedIndex];
        out.push({ el: el, value: opt && opt.dataset.optionValueId, inputs: [] });
      } else {
        var inputs = el.querySelectorAll('input[type="radio"][data-option-value-id]');
        if (!inputs.length) continue;
        var checked = el.querySelector('input[type="radio"][data-option-value-id]:checked');
        out.push({ el: el, value: checked && checked.dataset.optionValueId, inputs: inputs });
      }
    }
    return out;
  }

  function isColorGroup(g) {
    if (!g.inputs.length) return false;
    var legend = g.el.querySelector('legend');
    var name = (legend ? legend.textContent : '') + ' ' + (g.inputs[0].name || '');
    if (/colou?r|\bcor\b/i.test(name)) return true;
    return /swatch/i.test(g.el.className || '');
  }

  /* Um pedido por cor, montado como o tema monta: só as opções marcadas, na
     ordem da página (sem tamanho escolhido, vai só a cor). Disponíveis antes. */
  function colorJobs(vp) {
    var base = parse(vp.dataset.productUrl || '');
    var sid = sectionIdOf(vp);
    if (!base || !sid) return [];
    var groups = groupsOf(vp);
    var values = groups.map(function (g) { return g.value; });
    var ci = -1;
    for (var i = 0; i < groups.length; i++) { if (isColorGroup(groups[i])) { ci = i; break; } }
    if (ci === -1 || !values[ci]) return [];
    var view = new URLSearchParams(location.search).get('view');
    var jobs = [];
    var inputs = groups[ci].inputs;
    for (var j = 0; j < inputs.length; j++) {
      var id = inputs[j].dataset.optionValueId;
      if (!id || id === values[ci] || inputs[j].disabled) continue;
      if (inputs[j].dataset.connectedProductUrl) continue;
      var vals = values.slice();
      vals[ci] = id;
      vals = vals.filter(function (v) { return !!v; });
      var href = base.pathname + '?' + (view ? 'view=' + encodeURIComponent(view) + '&' : '') +
        'option_values=' + vals.join(',') + '&section_id=' + encodeURIComponent(sid);
      var key = keyOf(parse(href));
      if (key) jobs.push({ id: id, href: href, key: key, ok: inputs[j].dataset.optionAvailable !== 'false' });
    }
    return jobs.filter(function (x) { return x.ok; }).concat(jobs.filter(function (x) { return !x.ok; }));
  }

  function preloadImg(img, low) {
    if (!img) return;
    var pre = new Image();
    try { if (low) pre.fetchPriority = 'low'; } catch (e) { /* ok */ }
    pre.decoding = 'async';
    var sizes = img.getAttribute('sizes');
    var srcset = img.getAttribute('srcset');
    if (sizes && sizes !== 'auto') pre.sizes = sizes;
    if (srcset) pre.srcset = srcset;
    pre.src = img.getAttribute('src') || '';
  }

  /* Primeira foto da galeria da resposta (e miniaturas, se pedido). */
  function warmImages(text, thumbs, low) {
    try {
      var a = text.indexOf('<media-gallery');
      var b = text.indexOf('</media-gallery>', a);
      var src = a !== -1 && b !== -1 ? text.slice(a, b + 16) : text;
      var doc = new DOMParser().parseFromString(src, 'text/html');
      var g = doc.querySelector('media-gallery');
      if (!g) return;
      preloadImg(g.querySelector('slideshow-slide img'), low);
      if (!thumbs) return;
      var seen = {};
      var th = g.querySelectorAll('slideshow-controls img');
      for (var i = 0; i < th.length; i++) {
        var s = th[i].getAttribute('src') || '';
        if (!s || seen[s]) continue;
        seen[s] = true;
        preloadImg(th[i], true);
      }
    } catch (e) { /* ok */ }
  }

  var queue = [];
  var running = 0;
  function pump() {
    while (running < LIMIT && queue.length) {
      if (off() || modalOpen() || document.hidden) return;
      var job = queue.shift();
      if (fresh(job.key)) continue;
      running++;
      getText(job.href, job.key).then(function (t) {
        warmImages(t, !mobile, true);
      }, function () {}).then(function () {
        running--;
        pump();
      });
    }
  }

  function prefetchColors() {
    if (off() || saveData || modalOpen() || document.hidden) return;
    var vp = pdpPicker();
    if (!vp) return;
    queue = colorJobs(vp);
    pump();
  }

  var timer = null;
  function schedule(ms) {
    clearTimeout(timer);
    timer = setTimeout(function () {
      if (typeof window.requestIdleCallback === 'function') {
        window.requestIdleCallback(prefetchColors, { timeout: 2000 });
      } else {
        prefetchColors();
      }
    }, ms);
  }

  /* (3): intenção — mouse parado, foco ou toque numa cor */
  function inputFrom(t) {
    if (!t || !t.closest) return null;
    var label = t.closest('label');
    var input = label && label.querySelector('input[type="radio"][data-option-value-id]');
    if (!input && t.matches && t.matches('input[type="radio"][data-option-value-id]')) input = t;
    return input || null;
  }

  function onIntent(input) {
    if (!input || off() || saveData || modalOpen()) return;
    var vp = pdpPicker();
    if (!vp || !vp.contains(input)) return;
    var jobs = colorJobs(vp);
    for (var i = 0; i < jobs.length; i++) {
      if (jobs[i].id !== input.dataset.optionValueId) continue;
      getText(jobs[i].href, jobs[i].key).then(function (t) { warmImages(t, true, false); }, function () {});
      return;
    }
  }

  var hoverTimer = null;
  var hoverInput = null;
  document.addEventListener('pointerover', function (e) {
    if (e.pointerType && e.pointerType !== 'mouse') return;
    var input = inputFrom(e.target);
    if (!input || input === hoverInput) return;
    hoverInput = input;
    clearTimeout(hoverTimer);
    hoverTimer = setTimeout(function () { onIntent(input); }, 60);
  }, true);
  document.addEventListener('pointerout', function (e) {
    if (!hoverInput) return;
    var label = hoverInput.closest('label');
    if (label && e.relatedTarget && label.contains(e.relatedTarget)) return;
    clearTimeout(hoverTimer);
    hoverInput = null;
  }, true);
  document.addEventListener('pointerdown', function (e) { onIntent(inputFrom(e.target)); }, true);
  document.addEventListener('focusin', function (e) { onIntent(inputFrom(e.target)); }, true);

  /* Depois de cada troca no seletor principal, refaz a fila. */
  document.addEventListener('change', function (e) {
    var vp = pdpPicker();
    if (vp && e.target instanceof Node && vp.contains(e.target)) schedule(700);
  }, true);
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden && queue.length) pump();
  });

  function start() { schedule(mobile ? 1500 : 600); }
  if (document.readyState === 'complete') start();
  else window.addEventListener('load', start, { once: true });

  /* (4): mesmas fotos → não troca a galeria */
  function gallerySig(g) {
    var slides = g.querySelectorAll('slideshow-slide');
    if (!slides.length) return null;
    var parts = [];
    for (var i = 0; i < slides.length; i++) {
      var s = slides[i];
      var img = s.querySelector('img');
      parts.push((s.getAttribute('slide-id') || '') + '@' +
        (img ? (img.getAttribute('src') || '').split('?')[0] : '') +
        (s.hasAttribute('hidden') ? '#h' : ''));
    }
    return parts.join('|');
  }

  customElements.whenDefined('media-gallery').then(function () {
    var G = customElements.get('media-gallery');
    if (!G || G.prototype.__eePdpKeep) return;
    G.prototype.__eePdpKeep = true;
    var nativeReplace = G.prototype.replaceWith;
    G.prototype.replaceWith = function (next) {
      try {
        if (arguments.length === 1 && next && next.nodeType === 1 && next.localName === 'media-gallery' &&
            !this.closest('product-card, quick-add-dialog, dialog')) {
          var vp = pdpPicker();
          var sec = vp && vp.closest('.shopify-section');
          if (sec && sec.contains(this)) {
            var sig = gallerySig(this);
            if (sig && sig === gallerySig(next)) return;
          }
        }
      } catch (e) { /* segue o normal */ }
      return nativeReplace.apply(this, arguments);
    };
  });
})();

/* ===== Página de produto: barra de compra fixa desde o início no celular (28/09, Site · Conversão básica) =====
   O tema (assets/sticky-add-to-cart.js) só mostra a barra DEPOIS de o cliente passar pelo botão de compra,
   que no celular fica abaixo da dobra (foto + cor + tamanho). Aqui, só no celular (<750px) e só na página de
   produto: enquanto o botão principal ainda está ABAIXO da tela, a barra aparece; quando o botão entra na
   tela, ela some; depois de passar por ele, o próprio tema volta a mostrar. O botão da barra ganha o texto
   "Add to cart" (o tema mostra só o ícone no celular). Sem tamanho escolhido, o aviso do BMP (bmp-size-required.js)
   rola até o tamanho, como já fazia. Nenhum arquivo do tema foi editado. Para desligar: apagar este bloco. */
(function () {
  'use strict';
  if (!('IntersectionObserver' in window) || !window.matchMedia) return;
  var mq = window.matchMedia('(max-width: 749px)');
  var SEL = '.shopify-section[id$="__main"] sticky-add-to-cart[data-variant-available="true"]';
  function injectCss() {
    if (document.getElementById('ee-sticky-atc-css')) return;
    var st = document.createElement('style');
    st.id = 'ee-sticky-atc-css';
    st.textContent = '@media screen and (max-width: 749px){' +
      SEL + ' .sticky-add-to-cart__button{width:auto;min-width:var(--height-buy-buttons);padding-inline:18px;flex-shrink:0;white-space:nowrap}' +
      SEL + ' .sticky-add-to-cart__bar .add-to-cart-text__content{display:inline}' +
      SEL + ' .sticky-add-to-cart__info{min-width:0}' +
      '}';
    document.head.appendChild(st);
  }
  function init() {
    var sticky = null;
    var list = document.querySelectorAll('.shopify-section[id$="__main"] sticky-add-to-cart');
    for (var i = 0; i < list.length; i++) {
      if (!list[i].closest('dialog, product-card, .quick-add-modal')) { sticky = list[i]; break; }
    }
    if (!sticky) return;
    var bar = sticky.querySelector('[ref="stickyBar"]');
    var section = sticky.closest('.shopify-section');
    var pid = sticky.getAttribute('data-product-id');
    var form = section && pid ? section.querySelector('product-form-component[data-product-id="' + pid + '"]') : null;
    var buy = form ? form.closest('.buy-buttons-block') : null;
    if (!bar || !buy) return;
    injectCss();
    var ours = false;
    var buyVisible = true;
    function release() {
      if (ours) { ours = false; if (bar.getAttribute('data-stuck') === 'true') bar.setAttribute('data-stuck', 'false'); }
    }
    function update() {
      if (!mq.matches || buyVisible) { release(); return; }
      var r = buy.getBoundingClientRect();
      if (r.top >= (window.innerHeight || document.documentElement.clientHeight)) {
        if (bar.getAttribute('data-stuck') !== 'true') { bar.setAttribute('data-stuck', 'true'); ours = true; }
      }
    }
    new IntersectionObserver(function (entries) {
      var e = entries[entries.length - 1];
      if (!e) return;
      buyVisible = e.isIntersecting;
      update();
    }).observe(buy);
    var onMq = function () { update(); };
    if (mq.addEventListener) mq.addEventListener('change', onMq); else if (mq.addListener) mq.addListener(onMq);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();